<template>
    <div class="col-md-6 p-3">
        <button v-show="show" id="submit-button4"
                type="submit"
                @click="createPaymentIntent"
                data-style="expand-right"
                :disabled="isDisabledBtn"
                :class="{disabled : isDisabledBtn}"
                class="btn btn-red btn-sm btn-block ladda-button">
                        <span v-if="!loading" class="ladda-label">
                            {{ reference && isBankTrasferSelected ? trans.get('account.i_have_paid') : payButtonLabel }}
                        </span>
            <b-spinner v-if="loading" label="Spinning" class="align-middle"></b-spinner>
            <span class="ladda-spinner"></span>
        </button>
        <div v-if="!allowByOtherPayments" class="row">
            <div v-for="(invoices, ref) in pendingInvoices">
                <p style="line-height: 28px;">
                    Invoices
                    <strong>{{ pendingInvoicesStr(invoices) }}</strong>
                    are already linked by reference
                    <a :href="referenceUrl(ref)"><strong>{{ ref }}</strong></a>
                    and they are already pending approval or paid
                </p>
            </div>
        </div>
    </div>
</template>
<script>

import {mapFields} from "vuex-map-fields";

export default {
  name: 'pay-btn',
  props: {},
  data() {
    return {
      terms: false,
      legal: false,
      comment: '',
      invoice_number: null,
      pendingInvoices: {},
    };
  },
  mounted() {
    this.payButtonLabel = this.trans.get('account.pay');
  },
  methods: {
    createPaymentIntent: function () {
      this.loading = true;
      this.$emit('create-payment-intent');
    },
    pendingInvoicesStr(invoices) {
      return invoices.map(e => e.invoice_number).join(', ');
    },
    referenceUrl(ref) {
      return window.linked_invoices_url + '/' + ref;
    },
  },
  computed: {
    ...mapFields([
      'loading',
      'invoices',
      'reference',
      'paymentStatus',
      'selectedPaymentMethod',
      'payButtonLabel',
    ]),
    isDisabledBtn: function () {
      if (this.loading) {
        return true;
      }
      let disabled = false;
      if (this.$parent) {
        this.$parent.$children.map(function (component) {
          if (!component.isValid) {
            disabled = true;
          }
        });
      }
      return disabled;
    },
    isValid() {
      return true;
    },
    isBankTrasferSelected() {
      return this.selectedPaymentMethod === PAYMENT_METHOD_BANK_TRANSFER
    },
    show() {
      return this.allowByCurrentPayment && this.allowByOtherPayments;
    },
    allowByCurrentPayment() {
      return !this.selectedPaymentMethod
          || (this.selectedPaymentMethod
              && this.selectedPaymentMethod === PAYMENT_METHOD_CREDIT_CARD
              && this.paymentStatus !== PAYMENT_INTENT
              && this.paymentStatus !== PAYMENT_SUCCESS)
          || (this.selectedPaymentMethod
              && this.selectedPaymentMethod === PAYMENT_METHOD_BANK_TRANSFER
              && this.paymentStatus !== PAYMENT_SUCCESS
              && this.paymentStatus !== PAYMENT_PENDING_APPROVAL);
    },
    allowByOtherPayments() {
      let allow = true;
      let self = this;
      this.invoices.map(function (invoice) {
        if (invoice.intent_payments) {
          invoice.intent_payments.map(function (payment) {
            let hasPending = payment.status === PAYMENT_PENDING_APPROVAL
                || (payment.status === PAYMENT_INTENT && payment.payment_method.key === PAYMENT_METHOD_CREDIT_CARD)
                || (invoice.sum_left_to_pay === 0 && payment.status === PAYMENT_SUCCESS);
            if (hasPending && payment.reference !== self.reference) {
              if (!self.pendingInvoices[payment.reference]) {
                self.pendingInvoices[payment.reference] = [];
              }
              self.pendingInvoices[payment.reference].push(invoice);
              allow = false;
            }
          });
        }

      });
      return allow;
    }
  }
}
</script>
